if (!customElements.get('jersey-customization')) {
  customElements.define(
    'jersey-customization',
    class JerseyCustomization extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form[data-type="add-to-cart-form"]');
        this.numberSelect = this.querySelector('[data-jersey-number]');
        this.error = this.querySelector('[data-customization-error]');
        this.submitButton = this.form?.querySelector('button[type="submit"][name="add"]');

        if (!this.form || !this.numberSelect || !this.submitButton || this.dataset.ready === 'true') return;

        this.dataset.ready = 'true';
        this.setSelectionState(false);
        this.numberSelect.addEventListener('change', () => this.onNumberChange());
        this.form.addEventListener('submit', (event) => this.onSubmit(event), true);
      }

      hasValidNumber() {
        return /^(?:[1-9]|[12][0-9]|30)$/.test(this.numberSelect.value);
      }

      setSelectionState(selected) {
        if (selected) {
          this.submitButton.removeAttribute('data-jersey-number-missing');
        } else {
          this.submitButton.setAttribute('data-jersey-number-missing', 'true');
        }
      }

      onNumberChange() {
        const valid = this.hasValidNumber();
        this.setSelectionState(valid);
        if (valid) {
          this.clearError();
        } else if (this.numberSelect.value !== '') {
          this.showError();
        }
      }

      showError() {
        this.error.textContent = this.dataset.errorInvalid;
        this.error.hidden = false;
        this.numberSelect.setAttribute('aria-invalid', 'true');
        this.numberSelect.focus();
      }

      clearError() {
        this.error.textContent = '';
        this.error.hidden = true;
        this.numberSelect.removeAttribute('aria-invalid');
      }

      onSubmit(event) {
        if (this.hasValidNumber()) {
          this.clearError();
          return;
        }

        event.preventDefault();
        event.stopImmediatePropagation();
        this.setSelectionState(false);
        this.showError();
      }
    }
  );
}
